import { createLocale } from "./createLocale";

export const mt = createLocale({
  header: {
    title: "Mur globali. $2 għal kull Short. Kwalunkwe lingwa!",
    subtitle: "🔥Ħallas biss għar-riżultat – minn $0.089 sa $0.009 kull sekonda🔥",
  },
  steps: {
    uploadVideo: "Ittella' Vidjo",
    selectLanguages: "Agħżel Lingwi",
    conversionResult: "Konverżjoni u Riżultat",
  },
  upload: {
    dragAndDrop: "Iġbed u waqqa' l-fajl tal-vidjo tiegħek hawn",
    orClickToSelect: "jew ikklikkja biex tagħżel",
    supportedFormats: "Formati appoġġjati: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Daqs massimu tal-fajl: 200 MB",
    maxDuration: "• Tul massimu: 30 sek",
    chooseFile: "Agħżel fajl",
    selectedFile: "Fajl magħżul:",
    size: "Daqs:",
    fileTypeError: "Jekk jogħġbok agħżel fajl tal-vidjo",
    fileSizeError: "Id-daqs tal-fajl ({size} MB) jaqbeż il-limitu massimu ta' 200 MB",
    durationError: "It-tul tal-vidjo ({duration} sek) jaqbeż il-limitu massimu ta' 30 sek",
    fileReadError: "Ma jistax jinqara l-fajl tal-vidjo. Jekk jogħġbok ipprova fajl ieħor.",
  },
  languages: {
    sourceAudioLanguage: "Lingwa tal-awdjo tas-sors",
    targetAudioLanguage: "Lingwa tal-awdjo fil-mira",
    selectLanguage: "Agħżel lingwa...",
  },
  conversion: {
    replaceAudio: "Ikklona l-vuċi tiegħi",
    uploadVideoAndSelectLanguages: "Itella' vidjo u agħżel il-lingwi biex tkompli",
  },
  nav: {
    blog: "Blog",
  },
  footer: {
    privacyPolicy: "Politika tal-Privatezza",
    termsOfUse: "Termini tal-Użu",
  },
  languageOptions: {
    mt: "Malti",
  },
});
